import { useState } from 'react';

import { Check, Delete, Edit, ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Collapse, IconButton, TableCell, TableRow } from '@mui/material';

import { SchemaPropertyModel, SchemaSummaryModel } from '../../../api/api';
import CopyToClipboardButton from '../../../components/Clipboard/CopyToClipboardButton';
import { useEntityMutations } from '../Hooks/useEntityController';
import PropertyTypeIcon from './PropertyTypeIcon';
import SchemaSection from './SchemaSection';

interface Props {
	prop: SchemaPropertyModel;
	onDelete: (propertyName: string) => void;
	onEditProperty: (property: SchemaPropertyModel) => Promise<void> | void;
}

const SchemaPropertyRow: React.FC<Props> = ({ prop, onDelete, onEditProperty }) => {
	const { getEntitySummaryById } = useEntityMutations(prop.referenceSchemaContextId!);

	const [expanded, setExpanded] = useState(false);

	const [referenceSchema, setReferenceSchema] = useState<SchemaSummaryModel | null>(null);

	const toggle = async () => {
		if (!expanded) {
			// Only fetch details the first time it's expanded
			const details = await getEntitySummaryById(prop.referenceSchemaId!);
			setReferenceSchema(details);
			console.log(details);
		}
		setExpanded((prev) => !prev);
	};

	return (
		<>
			<TableRow>
				<TableCell>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
						<PropertyTypeIcon prop={prop} />
						<Box component="span" sx={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
							{prop.name}
						</Box>
						<CopyToClipboardButton value={prop.name} title="Copy property name to clipboard" edge={false} iconSize={14} sx={{ p: 0.25, flexShrink: 0 }} />
					</Box>
				</TableCell>
				<TableCell>
					{prop.referenceSchemaShortName}
					<IconButton size="small" onClick={toggle}>
						{expanded ? <ExpandLess /> : <ExpandMore />}
					</IconButton>
				</TableCell>
				<TableCell sx={{ px: 0.5, textAlign: 'center' }}>{prop.isRequired && <Check fontSize="small" />}</TableCell>
				<TableCell sx={{ px: 0.5, textAlign: 'center' }}>{prop.isMultiple && <Check fontSize="small" />}</TableCell>
				<TableCell></TableCell>
				<TableCell align="right">
					<IconButton
						size="small"
						onClick={() => {
							if (prop.name) {
								onEditProperty(prop);
							}
						}}
					>
						<Edit fontSize="small" />
					</IconButton>
					<IconButton
						size="small"
						onClick={() => {
							if (prop.name) {
								onDelete(prop.name);
							}
						}}
					>
						<Delete fontSize="small" />
					</IconButton>
				</TableCell>
			</TableRow>

			{expanded && (
				<TableRow sx={{ p: 0 }}>
					<TableCell colSpan={6} sx={{ p: 0 }}>
						<Collapse in={expanded} timeout="auto" unmountOnExit>
							<Box sx={{ p: 0, pl: 2 }}>
								<SchemaSection schema={referenceSchema!} />
							</Box>
						</Collapse>
					</TableCell>
				</TableRow>
			)}
		</>
	);
};

export default SchemaPropertyRow;
